const config = {
  NEXT_PUBLIC_API_URL:
    process.env.NODE_ENV === "production"
      ? "https://backend2.ljpr.in"
      : "http://localhost:8000",
  NODE_ENV: process.env.NODE_ENV || "development",
};

export default config;
